import { AxiosResponse } from 'axios';
import { ProcessObjectFile } from '../process-objects/list/types';
import { DeploymentType, FieldReport } from './field-report/types';
import { MeasurementGroupTypesEnum } from './create-measurement-group/create-measurement-group-schema';

export enum MeasurementGroupStatus {
	PROD = 'PROD',
	'PROD-MAINT' = 'PROD-MAINT',
	RETIRED = 'RETIRED',
	DEV = 'DEV',
	TEST = 'TEST',
	UNKNOWN = 'UNKNOWN'
}
export type MeasurementGroupDetails = {
	id: number;
	indirectProcessObjectId: number;
	name: string;
	status: MeasurementGroupStatus;
	latestMeasurementAt: string;
	devices: DeployedDevice[];
	graphCapacity: GraphCapacity;
	latestStatusLog: LatestStatusLog | null;
};
export type MeasurementGroupLoaderResponse = {
	measurementGroup: AxiosResponse<MeasurementGroupDetails>;
	fileList: AxiosResponse<ProcessObjectFile[]>;
	fieldReports: Promise<AxiosResponse<FieldReport[]>>;
	deploymentTypes: Promise<AxiosResponse<DeploymentType[]>>;
	measurementGroupStatuses: Promise<AxiosResponse<MeasurementGroupStatusType[]>>;
	generation: Promise<AxiosResponse<DataPoint[]>>;
};

export type DeployedDevice = {
	id: string;
	poId: number;
	site: string;
	landowner: string;
	siteId: number;
};

export type MeasurementGroupStatusUpdateRequest = {
	statusId: number;
	internalMessage: string;
	customerMessage: string;
	startDate: string | null;
	returnDate: string | null;
};

export type MeasurementGroupApplyRevisionRequest = {
	revisionDataFile: File;
};

export type MeasurementGroupStatusType = {
	statusId: number;
	statusName: string;
};

export type Series = {
	name: string;
	data: DataPoint[];
};

export type DataPoint = {
	timestamp: string;
	value: number;
};

export enum Priority {
	All = 'ALL',
	CurrentPrimaryXY = 'CURRENT_PRIMARY_XY',
	CurrentPrimaryYX = 'CURRENT_PRIMARY_YX',
	CurrentSecondaryXY = 'CURRENT_SECONDARY_XY',
	CurrentSecondaryYX = 'CURRENT_SECONDARY_YX',
	LastPrimaryXY = 'LAST_PRIMARY_XY',
	LastPrimaryYX = 'LAST_PRIMARY_YX',
	LastSecondaryXY = 'LAST_SECONDARY_XY',
	LastSecondaryYX = 'LAST_SECONDARY_YX'
}

export enum CalculationType {
	Power = 'POWER',
	ComplexPower = 'COMPLEX_POWER',
	ReactivePower = 'REACTIVE_POWER',
	Phase = 'PHASE'
}

export type CreateMeasurementGroupRequest = {
	name: string;
	type: keyof typeof MeasurementGroupTypesEnum;
	processObjectList: string[];
	objectList: string[];
};

export type GraphCapacity = {
	min: number;
	max: number;
};

export type UpdateCapacityRequest = {
	min: number;
	max: number;
};

export type LatestStatusLog = {
	customerMessage: string | null;
	internalMessage: string | null;
	endDate: string | null;
	startDate: string | null;
	returnDate: string | null;
	changedBy: string;
}
